import React from "react";
import { Spinner } from "react-bootstrap";
import "./LoaderPage.css";

function LoaderPage(props) {
  return (
    
    <div className={`${props.className} spinner_dashboard`}>
      <Spinner animation="grow" className="spinner" />
    </div>

  );
}
export default LoaderPage;
